module.exports = __webpack_public_path__ + "img/pdf1.dedce392.png";